// Bridge de compatibilidad: reexporta el cliente ya creado en supabaseClient.js
import { supabase } from './supabaseClient';

export { supabase };
export function ensureClient() { return supabase; }
